/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApplicableCertificate } from './ApplicableCertificate';
import {
    ApplicableCertificateFromJSON,
    ApplicableCertificateFromJSONTyped,
    ApplicableCertificateToJSON,
    ApplicableCertificateToJSONTyped,
} from './ApplicableCertificate';
import type { HotelSummary } from './HotelSummary';
import {
    HotelSummaryFromJSON,
    HotelSummaryFromJSONTyped,
    HotelSummaryToJSON,
    HotelSummaryToJSONTyped,
} from './HotelSummary';
import type { Hotel } from './Hotel';
import {
    HotelFromJSON,
    HotelFromJSONTyped,
    HotelToJSON,
    HotelToJSONTyped,
} from './Hotel';
import type { ApplicableFreeNightCredit } from './ApplicableFreeNightCredit';
import {
    ApplicableFreeNightCreditFromJSON,
    ApplicableFreeNightCreditFromJSONTyped,
    ApplicableFreeNightCreditToJSON,
    ApplicableFreeNightCreditToJSONTyped,
} from './ApplicableFreeNightCredit';

/**
 * 
 * @export
 * @interface HotelReservation
 */
export interface HotelReservation {
    /**
     * 
     * @type {HotelSummary}
     * @memberof HotelReservation
     */
    summary?: HotelSummary;
    /**
     * 
     * @type {Hotel}
     * @memberof HotelReservation
     */
    reservation?: Hotel;
    /**
     * 
     * @type {Array<ApplicableCertificate>}
     * @memberof HotelReservation
     */
    applicableCertificates?: Array<ApplicableCertificate> | null;
    /**
     * 
     * @type {Array<ApplicableFreeNightCredit>}
     * @memberof HotelReservation
     */
    applicableFreeNightCredits?: Array<ApplicableFreeNightCredit> | null;
}

/**
 * Check if a given object implements the HotelReservation interface.
 */
export function instanceOfHotelReservation(value: object): value is HotelReservation {
    return true;
}

export function HotelReservationFromJSON(json: any): HotelReservation {
    return HotelReservationFromJSONTyped(json, false);
}

export function HotelReservationFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelReservation {
    if (json == null) {
        return json;
    }
    return {
        
        'summary': json['summary'] == null ? undefined : HotelSummaryFromJSON(json['summary']),
        'reservation': json['reservation'] == null ? undefined : HotelFromJSON(json['reservation']),
        'applicableCertificates': json['applicable_certificates'] == null ? undefined : ((json['applicable_certificates'] as Array<any>).map(ApplicableCertificateFromJSON)),
        'applicableFreeNightCredits': json['applicable_free_night_credits'] == null ? undefined : ((json['applicable_free_night_credits'] as Array<any>).map(ApplicableFreeNightCreditFromJSON)),
    };
}

export function HotelReservationToJSON(json: any): HotelReservation {
    return HotelReservationToJSONTyped(json, false);
}

export function HotelReservationToJSONTyped(value?: HotelReservation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'summary': HotelSummaryToJSON(value['summary']),
        'reservation': HotelToJSON(value['reservation']),
        'applicable_certificates': value['applicableCertificates'] == null ? undefined : ((value['applicableCertificates'] as Array<any>).map(ApplicableCertificateToJSON)),
        'applicable_free_night_credits': value['applicableFreeNightCredits'] == null ? undefined : ((value['applicableFreeNightCredits'] as Array<any>).map(ApplicableFreeNightCreditToJSON)),
    };
}

